/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Pos_To_PublishInputs */

const en_queue_pos_to_publish = /** @type {(inputs: Queue_Pos_To_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase orders to publish`)
};

/**
* | output |
* | --- |
* | "Purchase orders to publish" |
*
* @param {Queue_Pos_To_PublishInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_pos_to_publish = /** @type {((inputs?: Queue_Pos_To_PublishInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Pos_To_PublishInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_pos_to_publish(inputs)
});